import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  transitions: {
    duration: { short },
    easing: { easeInOut }
  }
}: ComposedTheme) => ({
  fade: {
    '&-enter': {
      transition: `opacity ${short}ms ${easeInOut}`,
      display: 'block',
      opacity: 0
    },

    '&-enter-active': {
      opacity: 1
    },

    '&-enter-done': {
      display: 'block',
      opacity: 1
    },

    '&-exit': {
      transition: `opacity ${short}ms ${easeInOut}`,
      opacity: 1
    },

    '&-exit-active': {
      opacity: 0
    },

    '&-exit-done': {
      display: 'none'
    }
  }
});

export default createUseStyles(styles);
